const getQueryParameterByName = require('../helpers/GetQueryParam');

const addToCartUrl = _.get(window, 'mageglobal.uc.carturl');
const schoolCode = document.getElementById('uc-loader').getAttribute('data-school-code');
const productName = document.getElementById('uc-loader').getAttribute('data-product-name');
const configId = _.get(window, 'mageglobal.uc.config_id');

const ppFlagFromScript = document.getElementById('uc-loader').getAttribute('data-partial-payment');
const ppFlagFromMageglobal = _.get(window, 'mageglobal.partial_payment');
const ppFlag = ppFlagFromScript || ppFlagFromMageglobal || false;

const ppFlagActiveFromScript = document.getElementById('uc-loader').getAttribute('data-partial-payment-checked');
const ppFlagActiveFromMageglobal = _.get(window, 'mageglobal.partial_payment_checked');
const ppFlagActive = ppFlagActiveFromScript || ppFlagActiveFromMageglobal || false;
const addConfigToCart = getQueryParameterByName('uc_add_to_cart');

const MagentoLoader = {
  addToCartUrl,
  schoolCode,
  configId,
  ppFlag,
  ppFlagActive,
  addConfigToCart,
  productName
};

export default MagentoLoader;



// WEBPACK FOOTER //
// ./src/base/scripts/loaders/magento.js